export default __webpack_public_path__ + "static/media/write_reviews-orange.91840968.png";